import React from 'react';
import ReactDOM from 'react-dom/client';
import "bootstrap/dist/css/bootstrap.min.css"
import './index.css'
// Fruehzeitig einbinden: das Modul faengt "beforeinstallprompt" ab, das der
// Browser kurz nach dem Laden feuert - haeufig bevor React eingehaengt ist.
import './installPrompt';
import App from './App';


if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js')
        .then((registration) => {
          console.log('Service Worker registriert:', registration);
        })
        .catch((error) => {
          console.log('Service Worker Registrierung fehlgeschlagen:', error);
        });
    });
  }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App/>);
